export default {
    methods: {
        initSelectPicker() {
            window.$('.js-selectpicker').selectpicker({
                selectedTextFormat: 'count',
                countSelectedText: function(numSelected, numTotal) {
                    return numSelected === numTotal
                        ? this.title + ' Все'
                        : this.title + ' ' + numSelected
                }
            })
            setTimeout(function() {
                window.$('.select').removeClass('hidden')
            }, 100)
        }
    }
}
